module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter2",
    attrs: {
      "id": "fm1"
    }
  }, [_vm._v("ROUGH LANDING")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I gripped the rails at my sides so hard that no one, not even the huge alien porracci, could have pried my fingers loose. The air buffeted us from side to side as we dropped on an extremely steep glide path, but that’s normal. The idea is to get the drop ship on the ground as fast as possible, giving the enemy no time to target you with ground-to-air missiles. It doesn’t take much to do lethal damage to an airsled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We hit the ground, but not hard enough to burrow in. The sled skidded along the turf as compressed gas jets slowed us down. The terrain provided more breaking. We could hear underbrush, maybe even small trees, snapping and scraping the sides of the sled—the last part of the ride always seems to last an eternity. Finally, we stopped, tipped to the right, and the overhead hatches popped automatically. I looked over my unit, some furry, some scaly, all anxious.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I bellowed, “Up and out!” and everyone moved like lightning …")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e71d4778","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781936535408_epub_fm1_r1.vue
// module id = 57
// module chunks = 0